var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2C6.44772 2 6 2.44772 6 3V4.25H3C2.0335 4.25 1.25 5.0335 1.25 6V6.5C1.25 9.51343 3.38265 12.0288 6.22097 12.619C6.86232 14.9131 8.83292 16.6522 11.25 16.9536V20.1454C10.7486 20.3483 10.3483 20.7486 10.1454 21.25H9C8.58579 21.25 8.25 21.5858 8.25 22C8.25 22.4142 8.58579 22.75 9 22.75H15C15.4142 22.75 15.75 22.4142 15.75 22C15.75 21.5858 15.4142 21.25 15 21.25H13.8546C13.6517 20.7486 13.2514 20.3483 12.75 20.1454V16.9536C15.1671 16.6522 17.1377 14.9131 17.779 12.619C20.6174 12.0288 22.75 9.51343 22.75 6.5V6C22.75 5.0335 21.9665 4.25 21 4.25H18V3C18 2.44772 17.5523 2 17 2H7ZM3 5.75H6L6.00001 11.0083C4.11171 10.3803 2.75 8.59919 2.75 6.5V6C2.75 5.86193 2.86193 5.75 3 5.75ZM18 5.75H21C21.1381 5.75 21.25 5.86193 21.25 6V6.5C21.25 8.59919 19.8883 10.3803 18 11.0083V5.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.1dfda410dd023496346e001847e2a124.svg";
export { ForwardRef as ReactComponent };